import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { HelmetProvider } from '@saas-pages/shared/public/seo'
import { initMetrika } from '@saas-pages/shared/public/runtime'
import { App } from '@/app/App'
import { I18nProvider } from '@/shared/i18n'
import branding from '../branding.config'
import '@/styles/index.css'

initMetrika(branding.metrikaId)

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root not found in the document.')
const app = <StrictMode><HelmetProvider><I18nProvider><App /></I18nProvider></HelmetProvider></StrictMode>
if (root.hasChildNodes()) hydrateRoot(root, app)
else createRoot(root).render(app)
